import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleModule } from './schedule.module';
import { Day, Week, WorkWeek, Month, Agenda, MonthAgenda, TimelineViews, TimelineMonth, Resize, DragAndDrop } from '@syncfusion/ej2-schedule';
export var DayService = { provide: 'ScheduleDay', useValue: Day };
export var WeekService = { provide: 'ScheduleWeek', useValue: Week };
export var WorkWeekService = { provide: 'ScheduleWorkWeek', useValue: WorkWeek };
export var MonthService = { provide: 'ScheduleMonth', useValue: Month };
export var AgendaService = { provide: 'ScheduleAgenda', useValue: Agenda };
export var MonthAgendaService = { provide: 'ScheduleMonthAgenda', useValue: MonthAgenda };
export var TimelineViewsService = { provide: 'ScheduleTimelineViews', useValue: TimelineViews };
export var TimelineMonthService = { provide: 'ScheduleTimelineMonth', useValue: TimelineMonth };
export var ResizeService = { provide: 'ScheduleResize', useValue: Resize };
export var DragAndDropService = { provide: 'ScheduleDragAndDrop', useValue: DragAndDrop };
/**
 * NgModule definition for the Schedule component with providers.
 */
var ScheduleAllModule = /** @class */ (function () {
    function ScheduleAllModule() {
    }
    ScheduleAllModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, ScheduleModule],
                    exports: [
                        ScheduleModule
                    ],
                    providers: [
                        DayService,
                        WeekService,
                        WorkWeekService,
                        MonthService,
                        AgendaService,
                        MonthAgendaService,
                        TimelineViewsService,
                        TimelineMonthService,
                        ResizeService,
                        DragAndDropService
                    ]
                },] },
    ];
    /** @nocollapse */
    ScheduleAllModule.ctorParameters = function () { return []; };
    return ScheduleAllModule;
}());
export { ScheduleAllModule };
//# sourceMappingURL=schedule-all.module.js.map